module.exports = __webpack_public_path__ + "img/logo1.466d7d13.png";